// AlignCenterSmallIcon.tsx

import React from "react";

export const TextAlignCenterIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M0 12V10.6667H12V12H0ZM2.66667 9.33333V8H9.33333V9.33333H2.66667ZM0 6.66667V5.33333H12V6.66667H0ZM2.66667 4V2.66667H9.33333V4H2.66667ZM0 1.33333V0H12V1.33333H0Z"
        fill="currentColor"
      />
    </svg>
  );
};
